import { render } from "./RegistrationTabComponent.vue?vue&type=template&id=24061f4e&scoped=true"
import script from "./RegistrationTabComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationTabComponent.vue?vue&type=script&lang=js"

import "./RegistrationTabComponent.vue?vue&type=style&index=0&id=24061f4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24061f4e"]])

export default __exports__